import { render } from "./todo-form.vue?vue&type=template&id=bdbc8824"
import script from "./todo-form.vue?vue&type=script&lang=js"
export * from "./todo-form.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__